import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { MenuProps } from './MenuProps';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, FormControl, InputLabel, Select, Stack, TextField } from '@mui/material';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import './button.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      display: false,
    },
    title: {
      display: true,
      text: 'Satisfação do Cliente',
      position: 'left',
    },
    datalabels: {
      display: true,
      anchor: 'start',
      offset: -30,
      align: "start",
      color: "#fff",
      textStrokeColor: "#000",
      textStrokeWidth: 2,
      font: {
        size: 20,
        weight: "bold"

      },
    }
  },
};

export const ChartsNPS = () => {

  const [initialDate, setInitialDate] = useState(new Date());
  const [finalDate, setFinalDate] = useState(new Date());
  const [ticketsData, setTicketsData] = useState({
    data: [],
    count: 0,
  });

  useEffect(() => {
    handleGetTicketsInformation();
  }, []);

  const dataCharts = {

    labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => item.user),
    // labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => (item.hasOwnProperty('horario') ? `Das ${item.horario}:00 as ${item.horario}:59` : item.data)),
    datasets: [
      {
        label: 'Avaliação do usuário',
        data: ticketsData?.data.length > 0 && ticketsData?.data.map((item, index) => {
          return item.npsGeneral
        }),
        borderRadius: 10,
        backgroundColor: '#151d85',
      },

    ],
  };

  const handleGetTicketsInformation = async () => {
    try {

      const {data} = await api.get(`/dashboard/NPSAttendanceNote?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}`);
      setTicketsData(data);

    } catch (error) {
      toast.error('Erro ao buscar informações dos tickets');
    }
  }

  return (
    <>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        Avaliações NPS por usuários
      </Typography>

      <Stack direction={'row'} spacing={2} alignItems={'center'} sx={{ my: 2, }} >

        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
          <DatePicker
            value={initialDate}
            onChange={(newValue) => { setInitialDate(newValue) }}
            label="Data inicial"
            renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}

          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
          <DatePicker
            value={finalDate}
            onChange={(newValue) => { setFinalDate(newValue) }}
            label="Data final"
            renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}
          />
        </LocalizationProvider>

        <Button className="buttonHover" onClick={handleGetTicketsInformation} variant='contained'>Filtrar</Button>

      </Stack>
      <Bar options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px', }} />
    </>
  );
}